import './Foyer.scss';
import React, { FC } from 'react';
import { useFoyerConfig, useFoyerConfigDispatch } from './FoyerProvider';
import { useUserCurrent } from '@/components/provider/UserCurrentProvider';
import { useAnimationAddFrames } from '@/components/provider/RootEditProvider/AnimationAddFramesContextToken';
import Nav from './Nav/Nav';
import Service from './Service/Service';
import ButtonIcon from '@/components/basic/ButtonIcon/ButtonIcon';
import Icon from '@/components/extra/Icon/Icon';
import { useSafeUiAction } from '@/components/provider/RootEditProvider/useSafeUiAction';
import classNames from 'classnames';
import Loading from '@/components/basic/Loading/Loading';

type FoyerProps = Record<string, never>;

const Foyer: FC<FoyerProps> = () => {
    const foyerConfig = useFoyerConfig();
    const foyerConfigDispatch = useFoyerConfigDispatch();
    const { userCurrent } = useUserCurrent();
    const { openServiceMenu } = useSafeUiAction();
    const { openNavMenu } = useSafeUiAction();
    const { activeJob, currentBatch, totalBatches } = useAnimationAddFrames();

    return (
        <div className="Foyer">
            <nav
                className={classNames('Foyer_menu', {
                    isOpen: foyerConfig.showNav,
                })}
                aria-label="Hauptnavigation"
                id="site-nav"
            >
                <div className="Foyer_menu_wrap">
                    <Nav />
                </div>
            </nav>
            <nav
                className={classNames('Foyer_menu', {
                    isOpen: foyerConfig.showService,
                })}
                aria-label="Service-Navigation"
                id="site-service"
            >
                <div className="Foyer_menu_wrap">
                    <Service />
                </div>
            </nav>
            <section className="Foyer_hub">
                <div className="Foyer_hubWrap">
                    <ButtonIcon
                        icon="service"
                        label="Service-Menü öffnen"
                        onClick={() => {
                            openServiceMenu(() => {
                                foyerConfigDispatch({ type: 'TOGGLE_SERVICE' });
                            });
                        }}
                        aria-expanded="false"
                        aria-controls="site-service"
                    />
                    {typeof userCurrent?.isEditMode === 'string' && (
                        <div className="Foyer_hubInfo">
                            <Icon icon="edit" />
                            <span>{userCurrent.isEditMode}</span>
                        </div>
                    )}
                    {activeJob && (
                        <div className="Foyer_hubBatching">
                            <span>
                                Batch {currentBatch}/{totalBatches}
                            </span>
                        </div>
                    )}
                    <ButtonIcon
                        icon="navigation"
                        label="Hauptmenü öffnen"
                        onClick={() => {
                            openNavMenu(() => {
                                foyerConfigDispatch({ type: 'TOGGLE_NAV' });
                            });
                        }}
                        aria-expanded="false"
                        aria-controls="site-nav"
                    />
                </div>
                <Loading
                    type="element"
                    className="Loading-hideOnMounted"
                    variant="beam"
                />
            </section>
        </div>
    );
};

export default Foyer;
